import React, { useEffect } from 'react';
import { LoadingPageWrap } from './style';

const LoadingPage = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <LoadingPageWrap className="loadingPage">
      <img src="/images/icons/spinner.gif" alt="spinner" />
    </LoadingPageWrap>
  );
};

export default LoadingPage;
